import type { BWAPrognosisFunction } from '@adornis/accounting/bwa/api/bwaTrend.js';
import { deriveNextFiscalYearLabel } from '@adornis/accounting/bwa/api/bwaTrend.js';

/**
 * Martinus prognosis: exponentially weighted average over the booked years. The newest year gets
 * weight 1, every year further back half the previous one (w_i = 2^-i, i = years back from the
 * newest). A finite halving series sums to 2 − 2^(1−n), not 1, so the sum is normalized by the
 * actual weight total to make it a proper average:
 *
 *   prognose = Σ 2^-i · amount_i  /  Σ 2^-i
 */
export const halvingWeightedAveragePrognosis: BWAPrognosisFunction = history => {
  const newest = history.at(-1);
  if (!newest) return null;
  let weightSum = 0;
  let weightedSum = 0;
  for (const [stepsBack, point] of [...history].reverse().entries()) {
    const weight = 2 ** -stepsBack;
    weightSum += weight;
    weightedSum += weight * point.amountMinorUnit;
  }
  return {
    amountMinorUnit: Math.round(weightedSum / weightSum),
    interval: deriveNextFiscalYearLabel(newest.interval),
  };
};
